import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Hero } from '../components/Hero'
import { LiveMetrics } from '../components/LiveMetrics'
import { PipelineFlow } from '../components/PipelineFlow'
import { Features } from '../components/Features'
import { CodeExample } from '../components/CodeExample'
import { Pricing } from '../components/Pricing'
import { FAQ } from '../components/FAQ'
import { CTABand } from '../components/CTABand'
import { usePrefersReducedMotion } from '../lib/hooks'

export function HomePage() {
  const location = useLocation()
  const reducedMotion = usePrefersReducedMotion()

  // Deep links like /try-it (→ /#demo) and /#pricing should scroll to the anchor.
  useEffect(() => {
    if (!location.hash) return
    const id = location.hash.slice(1)
    const t = setTimeout(() => {
      document
        .getElementById(id)
        ?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' })
    }, 80)
    return () => clearTimeout(t)
  }, [location.hash, reducedMotion])

  return (
    <>
      <Hero />
      <LiveMetrics />
      <PipelineFlow />
      <Features />
      <CodeExample />
      <Pricing />
      <FAQ />
      <CTABand />
    </>
  )
}
